import form from '@wwdev/forms';
form.init('form');